import { env } from "../env";
// Theme
export const THEME_SET = "THEME_SET";
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
};

// Auth
export const AUTH_SIGN_IN_REQUEST = "AUTH_SIGN_IN_REQUEST";
export const AUTH_SIGN_IN_SUCCESS = "AUTH_SIGN_IN_SUCCESS";
export const AUTH_SIGN_IN_FAILURE = "AUTH_SIGN_IN_FAILURE";
export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";
export const AUTH_SIGN_UP_REQUEST = "AUTH_SIGN_UP_REQUEST";
export const AUTH_SIGN_UP_SUCCESS = "AUTH_SIGN_UP_SUCCESS";
export const AUTH_SIGN_UP_FAILURE = "AUTH_SIGN_UP_FAILURE";
export const AUTH_RESET_PASSWORD_REQUEST = "AUTH_RESET_PASSWORD_REQUEST";
export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAILURE = "AUTH_RESET_PASSWORD_FAILURE";
export const UPDATE_USER_PORT_AUTH = "UPDATE_USER_PORT_AUTH";

// STATUSES
export const INITIAL_SUBMIT = 0;
export const TEMPORARILY_SAVED = 2;
export const BEING_EDITED = 7;
export const AWAITING_DOCUMENTS_FROM_CITIZEN = 8;
export const ISSUING_FIRST_DEGREE_HEALTH_REFERRAL = 9;
export const ISSUING_SECOND_DEGREE_HEALTH_REFERRAL = 10;
export const FINISHED = 11;
export const RESUBMITTED = 12;
export const REJECTED_FROM_SERVICE = 25;
export const FOR_REJECT = 13;
export const ISSUING_SCHOOL_REFERRAL = 14;
export const ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_BLUE = 15;
export const APPROVED_AWAITING_COLLECTION = 16;
export const REJECTED_FROM_CITIZEN = 17;
export const ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_YELLOW = 18;
export const ISSUING_NAUTICAL_PAPER_PURCHASE_REFERRAL_RED = 19;
export const POSTPONE_RENDEZVOUS = 23;
export const MEDICAL_A_DEGREE_REJECTION = 21;
export const REVIEW = 22;
export const AWAITING_A_MEDICAL_REPORT = 20;
export const AWAITING_B_MEDICAL_REPORT = 24;

export const NEW_NAUTICAL_APPLICATION = "16";

//Bar Chart
export const NEW_NAUTICAL_APPLICATION_CHART = 16;
export const RESIGN_NAUTICAL = 18;
export const ISSUE_COPY_NAUTICAL = 23;

// Is service
export const SERVICE_SIDE = "1";
export const CLIENT_SIDE = "0";
export const NOONE_SIDE = "2";
export const TEMPORARILY_SAVED_SIDE = "3";
export const PARADOTHIKE = "4";

// DOCS
export const DOC_STATUS_APPROVED = 1;
export const DOC_STATUS_PENDING = 3;
export const DOC_STATUS_REJECTED = 2;

export const GENDER_MALE = "1";
export const GENDER_FEMALE = "2";

//Tables for Options on new Nautical Issue
export const retiredOptions = [
  { id: 1, dscr: "Retired up to 64 year old" },
  { id: 2, dscr: "Not Retired" },
];

export const educationLevel = [
  { id: 1, dscr: "Elementary school Graduate" },
  { id: 2, dscr: "High school graduate or higher education graduate" },
];

// Table for Gender
export const gender = [
  { id: 1, dscr: "Male" },
  { id: 2, dscr: "Female" },
];

//Table for reason copy nautical
export const reasonCopyNauticalTable = [
  { id: 1, dscr: "Nautical Issue Lost or Stolen" },
  { id: 2, dscr: "Change Color of Nautical Issue" },
];

//Colors for PD selection
export const NAUTICALPDBLUE = "blue";
export const NAUTICALPDRED = "red";
export const APOLITIRIO = "Απολυτήριο";
export const NAUTICAL104 = 28;
export const NAUTICAL260 = 38;
export const APOLITIRIOGIMNASIOU = "Απολυτήριο Γυμνασίου";
export const APOLITIRIODIMITIKOU = "Απολυτήριο Δημοτικού ή ανώτερο";

// Reason of copy nautical issue
export const STOLENORLOST = 1;
export const CHANGECOLOR = 2;

export const PSIFIAKIFOTOGRAFIAID = 21;

export const PHOTOFORREFERRAL =
  "Ψηφιακή πρόσφατη φωτογραφία τύπου ταυτότητας ή διαβατηρίου";
export const IPEUTHINI_DILOSI_PER_IDIOTITAS = 22;
export const UPETHINI_DILWSI_TITLE = `Υπεύθυνη Δήλωση.pdf`;
export const ABROAD_BIRTH_PLACE_ID = 1500000000;

// Validation
export const PHONE_NUMBER_LENGTH = 10;
export const MOBILE_NUMBER_LENGTH = 10;
export const POSTAL_CODE_LENGTH = 5;
export const AMKA_LENGTH = 11;
export const AFM_LENGTH = 9;
export const FIELD_IS_REQUIRED = "Field is required";
export const FIELD_MUST_BE_ONLY_NUMBERS = "Field must be only numbers";
export const FIELD_MUST_BE_ELEVEN_DIGITS = "Field must be 11 digits";
export const PHONE_NUMBER_MUST_BE_10_DIGITS = "Phone number must be 10 digits";
export const MOBILE_NUMBER_MUST_BE_10_DIGITS =
  "Mobile number must be 10 digits";
export const POSTAL_CODE_MUST_BE_5_DIGITS = "Postal code must be 5 digits";
export const REQUIRED_DOCUMENTS_MISSING = "Required documents missing";

export const FOR_ME_IS_TRUE = "1";
export const GR_CODE_CRIMINAL = "101";
export const eParavoloAVathmias = 31;
export const eParavoloBVathmias = 32;
export const checkEParavoloAVathmias = 33;
export const checkEParavoloBVathmias = 34;
export const STATUS_DESMEUMENO_PARAVOLO = 3;

export const NEO_PARAVOLO = 1;
export const PLIROMENO_PARAVOLO = 2;
export const PLIROMI_SE_EKSELIKSI_PARAVOLO = 5;
// Goverment services

export const PORT_AUTH_LOGIN_URL = env.REACT_APP_PORT_AUTH_LOGIN_URL;

export const PORT_AUTH_LOGOUT_URL = env.REACT_APP_PORT_AUTH_LOGOUT_URL;

export const TAXIS_LOGIN = env.REACT_APP_TAXIS_LOGIN;

export const TAXIS_LOGOUT_URL = env.REACT_APP_TAXIS_LOGOUT_URL;

export const Appication_A_URL = env.REACT_APP_Appication_A_URL;
export const Appication_B_URL = env.REACT_APP_Appication_B_URL;
export const Appication_C_URL = env.REACT_APP_Appication_C_URL;


// Web services
export const HOST_URL =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:4000"
    : `${window.location.origin}/ws`;

// production "http://websrv.ynanp.gr/ws";
